import * as React from 'react';
import * as ReactDOM from 'react-dom'
import {ConnectedRouter, routerMiddleware} from "connected-react-router";
import { Routes } from "./routes";
import { Provider } from 'react-redux';
import { createRootReducer } from './Reducers/RootReducer';
import thunk from "redux-thunk";
import { applyMiddleware, compose, createStore } from "redux";
import { PreloadData } from './Definitions/Generated/PreloadData';
declare const PRELOAD_DATA: PreloadData;

//@ts-ignore
import { createBrowserHistory } from "history";

const history = createBrowserHistory();

const store = createStore(
    createRootReducer(history),
    compose(
        applyMiddleware(
            thunk,
            routerMiddleware(history)
        ),
        (window as any).__REDUX_DEVTOOLS_EXTENSION__ ? (window as any).__REDUX_DEVTOOLS_EXTENSION__() : (f: any) => f
    )
);

const render = () => {
    ReactDOM.render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <Routes />
            </ConnectedRouter>
        </Provider>,
        document.getElementById('root')
    );
};
render();